export default "__VITE_ASSET__37Qsx0c$__"